'use strict';
const { locations: { codeSwap = {}, airportMatch = {}, extraAirports = {} } } = require('../../../../config');
const airportCodes = require( '../../../../config/exports/airportCodes.json');

const getAirportInfo = (pageName, matchAny) => {
  let location;
  const airportsList = Object.assign({}, airportCodes, extraAirports);
  Object.keys(airportsList).map( key => {
    const item = airportsList[key];
    let regEx = new RegExp( item.pattern );
    if ((regEx).test(pageName)) {
      location = {
        name: item.name,
        code: codeSwap[item._airport] || item._airport,
        pattern: item.pattern
      };
    }
    if (!location) {
      regEx = new RegExp( item.name.toLowerCase().replace( / /g, '-' ));
      if ((regEx).test(pageName)) {
        location = {
          name: item.name,
          code: codeSwap[item._airport] || item._airport,
          pattern: item.pattern
        };
      }
    }
  });
  if (!location && matchAny) {
    return ({
      name: airportsList.gatwick.name,
      code: airportsList.gatwick._airport
    });
  }
  return location;
};

module.exports = getAirportInfo;



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/getAirportInfo.js